<div *ngFor="let order of absenceList$ | async; let i = index">
  <ion-card
    #absenceRow
    [ngClass]="{ 'selected-item': i === (selectedIndex$ | async) }"
    class="card-list-item">
    <ion-card-content
      (click)="onClick(order)"
      (keydown.enter)="onClick(order)"
      (mouseover)="onHover(i)">
      <div *ngFor="let col of tableColumns$ | async">
        <div *ngIf="col.selected">
          <ion-label class="admia-list-item-title">
            {{ (col.text | translate) + ': ' }}
          </ion-label>
          <ion-text>{{ order[col.name] }}</ion-text>
        </div>
      </div>
    </ion-card-content>
  </ion-card>
</div>
